import { SxProps, Theme } from "@mui/material/styles";

export const customFilterFormStyles = {
  ChipFilterCount: {
    marginLeft: 1,
    height: "20px",
    fontSize: "0.75rem",
    backgroundColor: "#1976d2",
    color: "white",
    "& .MuiChip-label": {
      paddingLeft: "6px",
      paddingRight: "6px",
    },
  },
  FilterListIcon: {
    marginRight: 0.5,
  },
  buttonOpen: {
    marginLeft: 1,
    textTransform: "none",
    fontSize: "0.875rem",
  },
  Box: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 999,
  },
  container: {
    position: "absolute",
    top: "100%",
    left: "40%",
    transform: "translateX(-50%)",
    zIndex: 1000,
    padding: 2,
    backgroundColor: "white",
    border: "1px solid #e0e0e0",
    borderRadius: 2,
    width: "300px",
    maxWidth: "800px",
    minWidth: "600px",
    boxShadow: "0px 8px 24px rgba(0,0,0,0.15)",
    backdropFilter: "blur(4px)",
    animation: "slideDown 0.2s ease-out",
    "@keyframes slideDown": {
      "0%": {
        opacity: 0,
        transform: "translateX(-50%) translateY(-10px)",
      },
      "100%": {
        opacity: 1,
        transform: "translateX(-50%) translateY(0px)",
      },
    },
  } as SxProps<Theme>,

  headerRow: {
    display: "grid",
    gridTemplateColumns: "40px 1fr 1fr 1fr",
    gap: 2,
    marginBottom: 1,
    alignItems: "center",
  } as SxProps<Theme>,

  headerText: {
    fontSize: "0.875rem",
    fontWeight: 500,
    color: "#666",
  } as SxProps<Theme>,

  filterRow: {
    display: "grid",
    gridTemplateColumns: "40px 1fr 1fr 1fr",
    gap: 2,
    marginBottom: 2,
    alignItems: "center",
  } as SxProps<Theme>,

  deleteButton: {
    minWidth: "32px",
    width: "32px",
    height: "32px",
    padding: 0,
    color: "#666",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
    "&:disabled": {
      color: "#ccc",
    },
  } as SxProps<Theme>,

  select: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#e0e0e0",
    },
  } as SxProps<Theme>,

  placeholderText: {
    color: "#999",
  } as React.CSSProperties,

  textField: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#e0e0e0",
    },
    width: "190px",
  } as SxProps<Theme>,

  actionButtonsContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: 1,
    borderTop: "1px solid #f0f0f0",
  } as SxProps<Theme>,

  actionButton: {
    color: "#1976d2",
    textTransform: "uppercase",
    fontSize: "0.75rem",
    fontWeight: 500,
    "&:hover": {
      backgroundColor: "rgba(25, 118, 210, 0.04)",
    },
  } as SxProps<Theme>,

  applyButtonContainer: {
    marginTop: 2,
    paddingTop: 2,
    borderTop: "1px solid #f0f0f0",
    textAlign: "right",
  } as SxProps<Theme>,

  applyButton: {
    textTransform: "none",
    fontSize: "0.875rem",
    paddingX: 3,
  } as SxProps<Theme>,

  iconStyle: {
    fontSize: "16px",
  } as React.CSSProperties,

  autocompleteOption: {
    fontSize: "0.80rem",
    padding: "4px 8px",
  } as React.CSSProperties,
};
